
import GoogleImageSearch from '../google'
import config from "../config"

import {
    addText
} from "./index"

// Action called to start data fetch from Google Image Search
export const searchFetch = (qry) => {
    console.log("Searching for event caller")

    return (dispatch) => {

        dispatch(searchQuery(qry))
        fetchFromGoogleAPI(dispatch, qry)

    }

}

export const searchQuery = (qry) => {

    return function (dispatch, getState) {

        let rotation = document.getElementById("camera").getAttribute("rotation")

        switch (getState().globalState.searchType) {
            case "IMAGE_SEARCH":
                dispatch(fetchFromGoogleAPI(rotation, qry))
            break;

            case "TEXT_SEARCH":
                dispatch( addText(qry, rotation.x, rotation.y) )
            break;

            default:
            break;
        }

        return {
            type: "SEARCH_FETCH",
            query: qry
        }
    }

}


export const setResult = (res, x, y) => {
    return {
        type: "SEARCH_DONE",
        results: res,

        x: x,
        y: y,
    }
}

// Action called when request result if returned
export const searchResult = (res, x, y) => {
    
    return (dispatch, getState) => {

        if (getState().globalState.worldView === "WORLD_VIEW") {
            return
        }

        dispatch( setResult(res, x, y) )
    } 
}

export const searchError = () => {

    return {
        type: "SEARCH_ERROR",
    }
}


/**
 * 
 * Get's Image Results using Google Image Search API
 * 
 * @param {vec3} rotation 
 * 
 */
const fetchFromGoogleAPI = (rotation, query) => {

    return function (dispatch) {
        fetch("https://www.googleapis.com/customsearch/v1?key="+config.search_key+"&cx="+config.search_cx+"&searchType=image&q="+encodeURIComponent(query))
        .then( (res) => res.json() )
        .then( (res) => {

            let imgs = res.items.map( (i) => {
                return {
                    src: i.image.thumbnailLink,
                    srcHigh: i.link,
                    width: i.image.thumbnailWidth,
                    height: i.image.thumbnailHeight,
                }
            } );

            dispatch(searchResult(imgs, rotation.x, rotation.y))

        } )
        .catch( (err) => {
            console.log("Error with normal search", err);
            console.error(err);

            dispatch(fetchFromCustomApi(rotation))
        } )
    } 
   
}

/**
 * 
 * Fetch image results from google search API "hack"
 * 
 * @param {vec3} rotation 
 * 
 */
const fetchFromCustomApi = (rotation, query) => {

    return function (dispatch) {

        GoogleImageSearch.searchImage(query)
        .then((res) => {
            // this.props.searchResult(res.splice(0,10), rotation.x, rotation.y)

            dispatch(searchResult(res.splice(0,10), rotation.x, rotation.y))

        })
        .catch((err) => {
            console.log(err);
            // this.props.searchError()

            dispatch(searchError())
        })

    }

}


// WEBPACK FOOTER //
// ./src/actions/search.js